export const setCookie = (name, value, expiration_date) => {
  expiration_date && (expiration_date = new Date(expiration_date).toUTCString());
  const c_value = escape(value) + (expiration_date === null || expiration_date === undefined ? '' : '; expires=' + expiration_date);
  document.cookie = name + '=' + c_value;
};

export const isCookieExist = (cookie_name) => {
  return document.cookie.indexOf(cookie_name) !== -1;
};
